import {
  Box,
  Fade,
  IconButton,
  LinearProgress,
  Paper,
  Tooltip,
  Typography,
} from "@mui/material";
import { useReport } from "../context/ReportContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";

const ReportProgressBar = () => {
  const { isExporting, cancelReport } = useReport();

  return (
    <Fade in={isExporting}>
      <Paper
        elevation={3}
        sx={{
          position: "fixed",
          top: 3,
          right: 4,
          width: 280,
          p: 2,
          zIndex: 9999,
          borderRadius: 2,
          borderLeft: "4px solid #1976d2",
          display: "flex",
          flexDirection: "column",
          gap: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
          }}
        >
          <Box>
            <Typography
              variant="subtitle2"
              fontWeight="bold"
              sx={{ lineHeight: 1 }}
            >
              Exportando Arquivo
            </Typography>
          </Box>

          <Tooltip title="Cancelar exportação">
            <IconButton
              size="small"
              onClick={cancelReport}
              sx={{ mt: -1, mr: -1, color: "error.main" }}
            >
              <FontAwesomeIcon icon={faClose} fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>

        <LinearProgress
          variant="indeterminate"
          sx={{ height: 6, borderRadius: 1 }}
        />
      </Paper>
    </Fade>
  );
};

export default ReportProgressBar;
